import { render } from "./TaminKonandegan.vue?vue&type=template&id=504c7bca&scoped=true"
import script from "./TaminKonandegan.vue?vue&type=script&lang=js"
export * from "./TaminKonandegan.vue?vue&type=script&lang=js"

import "./TaminKonandegan.vue?vue&type=style&index=0&id=504c7bca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504c7bca"]])

export default __exports__